// https://tm2support.atlassian.net/browse/TM2-2849
const chfId = 1;

export const currenciesFilter = (currency: { id: number }) => currency?.id !== chfId;
